import {
  B_23,
  BANNER_DEFAULTS,
  hideB23Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B23_PLASMIC_PROPS = {
  b23Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_23].heading,
    description: "Main heading (B23 only)",
    hidden: hideB23Props,
  },
  b23Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_23].description,
    description: "Description text (B23 only)",
    hidden: hideB23Props,
  },
};
